import { InputNumber, Select, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";

import { Form, Input } from "antd";
import { Note } from "assets";
import {
  handleCaculatorForAxis,
  handleCaculatorForCyl,
  handleCaculatorForSph,
} from "pages/Refractive/Caculator copy/CaculatorForOther";
import e from "cors";

export const optionsTypeLens = [
  {
    label: "Chọn",
    value: "select",
  },
  {
    label: "Đơn tròng - Nhìn xa",
    value: "singleDistance",
  },
  {
    label: "Đơn tròng - Nhìn gần",
    value: "singleNear",
  },
  {
    label: "Hai tròng",
    value: "bifocal",
  },
  {
    label: "Đa tròng",
    value: "progressive",
  },
  {
    label: "Hai tròng - D",
    value: "dBifocal",
  },
  {
    label: "Hai tròng - KT",
    value: "ktBifocal",
  },
];

const glassesPrescriptionColumns1 = (side: string, form) => {
  const columns: ColumnsType = [
    {
      title: "-",
      dataIndex: "none",
      width: "20%",
    },
    {
      title: "Cầu",
      dataIndex: "sph",

      render: (
        text: string | number,
        record: { key: string | number },
        index
      ) => (
        <Form.Item name={["glassesPrescriptionDto", side, "tb1", "sph", index]}>
          <Input
            onChange={(e) => {
              handleCaculatorForSph(
                index,
                form,
                side,
                e.target.value,
                "glassesPrescriptionDto"
              );
            }}
          />
        </Form.Item>
      ),
      width: "20%",
    },
    // Cyl
    {
      title: "Trụ",
      dataIndex: "cyl",
      render: (
        text: string | number,
        record: { key: string | number },
        index
      ) => (
        <Form.Item name={["glassesPrescriptionDto", side, "tb1", "cyl", index]}>
          <Input
            disabled={index === 1 ? true : false}
            onChange={(e) =>
              handleCaculatorForCyl(
                index,
                form,
                side,
                e.target.value,
                "glassesPrescriptionDto"
              )
            }
          />
        </Form.Item>
      ),
      width: "20%",
    },
    // Axis
    {
      title: "Trục",
      dataIndex: "axis",
      render: (
        text: string | number,
        record: { key: string | number; axis: string },
        index
      ) => (
        <Form.Item
          name={["glassesPrescriptionDto", side, "tb1", "axis", index]}
        >
          <Input
            disabled={index === 1 ? true : false}
            onChange={(e) =>
              handleCaculatorForAxis(
                index,
                form,
                side,
                e.target.value,
                "glassesPrescriptionDto"
              )
            }
          />
        </Form.Item>
      ),
      width: "20%",
    },
    {
      title: "Thị lực",
      dataIndex: "vision",
      render: (
        text: string | number,
        record: { key: string | number; vision: string },
        index
      ) => (
        <Form.Item
          name={["glassesPrescriptionDto", side, "tb1", "vision", index]}
        >
          <Input />
        </Form.Item>
      ),
      width: "20%",
    },
  ];

  return columns;
};

const glassesPrescriptionColumns2 = (side: string) => {
  const glassesPrescriptionColumns: ColumnsType = [
    {
      title: " name",
      dataIndex: "name",
      render: (text: string | number, record: { key: string | number }) => (
        <Typography>{text}</Typography>
      ),
      width: "20%",
      align: "left",
    },
    {
      title: "",
      dataIndex: "",
      align: "left",
      render: (
        text: string | number,
        record: { key: string | number; type: string; suffix: JSX.Element }
      ) => {
        if (record.key === 2) {
          return (
            <Form.Item
              name={["glassesPrescriptionDto", side, "tb2", "mpd"]}
            >
              <Input
                suffix="mm"
                onKeyPress={(e) => {
                  const allowedCharacters = /[0-9.,/]/;
                  const isValidCharacter = allowedCharacters.test(e.key);

                  if (!isValidCharacter) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          );
        } else if (record.key === 1) {
          return (
            <Form.Item
              name={["glassesPrescriptionDto", side, "tb2", "lensType"]}
            >
              <Select options={optionsTypeLens} allowClear />
            </Form.Item>
          );
        } else if (record.key === 3) {
          return (
            <Form.Item name={["glassesPrescriptionDto", side, "tb2", "advice"]}>
              <Input suffix={<Note />} />
            </Form.Item>
          );
        }
      },
      width: "80%",
    },
  ];
  return glassesPrescriptionColumns;
};

export { glassesPrescriptionColumns1, glassesPrescriptionColumns2 };
